import React from 'react';
import PropTypes from 'prop-types';
import styles from './RegistrationContainer.scss';
import REGISTRATION_FIELDS from './constants';

class RegistrationPasswordsBlock extends React.Component {
  render() {
    const { translate, renderPasswordInput } = this.props;
    return (
      <div className={styles.rowBlock}>
        <div className={styles.columnBlock}>
          <div className={styles.title}>
            {translate('authenticationPage', 'password')}
          </div>
          {renderPasswordInput(REGISTRATION_FIELDS.PASSWORD)}
        </div>
        <div className={styles.columnBlock}>
          <div className={styles.title}>
            {translate('authenticationPage', 'repeatPassword')}
          </div>
          {renderPasswordInput(REGISTRATION_FIELDS.REPEAT_PASSWORD)}
        </div>
      </div>
    );
  }
}

RegistrationPasswordsBlock.propTypes = {
  translate: PropTypes.func,
  renderPasswordInput: PropTypes.func
};

export default RegistrationPasswordsBlock;
